import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import TitreAxe from '../components/titre-axe.js'
import SvgPersonnage from "../../images/personnage.svg"
import BtnLePalaisMontcalm from '../components/btn-le-palais-montcalm.js'
import BtnHenrietteBelley from '../components/btn-henriette-belley.js'
import BtnCapsuleViolons from '../components/btn-capsule-violons.js'
import BtnViolons from '../components/btn-violons-du-roy.js'
import InfoBox from '../components/info.js'
import DessinSymeon from './../../images/A2P StSimeon_HMatte.jpg'
import styles from '../components/index.module.css';
import ImageFooter from '../components/image-footer-axe2.js'
import FragAxe2 from '../components/frag-axe2.js'

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'fondations'}}/>
        <SidebarLeft>
          <div style={{width : "100%", height: "786px", display: "flex", flexDirection: "column", justifyContent: "space-between",alignItems: "flex-end", paddingBottom: "1.45rem"}}>
            <div style={{maxWidth: "520px", width: "70%", height: "auto", alignSelf: "center"}}>
                <div className='metadata--wrapper'>
                    <img src={DessinSymeon} alt=""/>
                    <InfoBox>Syméon est un personnage. Illustration de Hema, Ludovica, 2017.</InfoBox>
                </div>
            </div>
        </div>
        </SidebarLeft>
        <Container>
            <TitreAxe>Monuments</TitreAxe>
            <SvgPersonnage/>
            <h1>Syméon<br/><span className={styles['date']}>-66 BC - 00</span></h1>
            <p>Selon l’Évangile de Saint-Luc, c’est au temple de Nazareth qu’un voyageur du nom de Syméon reconnut en Jésus le Messie attendu. Personnage secondaire mais fondamental du christianisme prophétique, Syméon aurait été averti bien à l’avance par le Saint-Esprit de cette rencontre. Ses visions lui auraient révélé qu’il ne mourrait pas avant d’avoir reconnu le Christ, et qu’une fois la rencontre et la reconnaissance consumée, il s’éteindrait bienheureux. 1726 ans plus tard, l’histoire de Syméon inspire la cantate BWV 82 au compositeur J.S. Bach.</p>
            <FragAxe2/>
        </Container>
        <SidebarRight>
            <BtnCapsuleViolons/>
            <BtnLePalaisMontcalm/>
            <BtnHenrietteBelley/>
            <BtnViolons/>
        </SidebarRight>
    </FlexContainer>
        <ImageFooter/>
    </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/symeon.js